<template>
<div class="container my-4" style="min-height:600px">
   <div v-if="loading">
            <hollow-dots-spinner class="loading_card_spinner" :animation-duration="1000" :dot-size="35" :dots-num="3"
                color="var(--primary-color)" />
        </div>
    <div v-else class="row g-5 confirm_page">
      <!-- 📄 العمود الأيسر: معلومات الطلب -->
      <div class="col-lg-7">
        <!-- شريط النجاح -->
        <div class="d-flex align-items-center mb-3 invoice_page_div">
        <div class="check-wrapper me-2">
  <span class="check-icon">&#10003;</span>
</div>
          <div>
            <small class="text-muted">{{$t('Confirmation')}} # {{ DBitems.invoice_id }}</small>
            <h4 class="m-0">{{$t('Thank you')}} {{ DBitems.user.name }}!</h4>
          </div>
        </div>

        <!-- الخريطة + تأكيد الطلب -->
        <div class="card order-card mb-4">
          <!-- خريطة ثابتة (يمكن استبدال الرابط أو المفتاح) -->
        
          <div class="card-body small">
            <p class="mb-0">{{$t('Your order is confirmed')}} ,{{ DBitems.status }}</p>
            <p class="text-muted">{{$t("You'll receive a confirmation email with your order number shortly.")}}</p>

  <div class="offers-row d-flex align-items-center mx-n3 px-3 py-3">

</div>

          </div>
        </div>

        <!-- تفاصيل الطلب -->
        <div class="card order-card mb-4">
          <div class="card-header bg-white d-flex justify-content-between align-items-center" style="border-bottom: none;">
            <span>{{$t('Order details')}}</span>
  <a v-if="this.$localStorage.get(this.$store.storeName) == null" @click="$router.push({
                            name: 'profile',
                            params: {
                                storeName: $store.storeName,
                                lang: $i18n.locale
                            },
                        });"
                         class=" small" style="text-decoration: underline; color: #000;">{{$t('View account')}}</a>
                           <a v-else @click="$router.push({
                            name: 'login',
                            params: {
                                storeName: $store.storeName,
                                lang: $i18n.locale
                            },
                        });"
                         class=" small" style="text-decoration: underline; color: #000;">{{$t('View account')}}</a>          </div>
          <div class="card-body small">
            <div class="row">
              <div class="col-sm-6 mb-3">
                <p class="fw-semibold mb-2">{{$t('Contact information')}}</p>
                <p class="mb-0">{{ DBitems.user.email }}</p>
              </div>
              <div class="col-sm-6 mb-3">
                <p class="fw-semibold mb-2">{{ $t("paymentType") }}</p>
                <p class="mb-0">{{ DBitems.payment_type }}<br>{{ DBitems.total_price*$store.state.rate }} {{$store.state.UnitPrice}}</p>
              </div>
              <div class="col-sm-6 mb-3">
                <p class="fw-semibold mb-2">{{$t('Shipping address')}}</p>
                <address class="mb-0">
                   {{ DBitems.address.city }},
                    {{ DBitems.address.region }}, {{ DBitems.address.street }}
                  {{ DBitems.user.phone }}
                </address>
              </div>
             
            </div>
          </div>
        </div>

<div class="d-flex justify-content-between align-items-center mt-4 invoice_page_div">
  <p class="small mb-0">{{$t('Need help?')}} <router-link :to="{
                  name: 'contactUs',
                  params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }"  class="text-decoration-none">{{$t('Contact Us')}}</router-link></p>
  <router-link :to="{
                  name: 'home',
                  params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }" class="btn btn-dark " style="padding: 10px;">{{$t('Continue shopping')}}</router-link>
</div>      </div>

      <!-- 🛒 العمود الأيمن: ملخص الطلب -->
      <div class="col-lg-5">
        <!-- شعار المتجر -->
      

        <!-- بطاقة المنتج + الإجمالي -->
      <div class="header-container">
    <div class="logo">
      <img :src="this.$store.state.logo" class="confirm_logo">
    </div>
    <div class="cart-icon" @click="$router.push({
        name: 'shoppingCart',
        params: {
            storeName: $store.storeName,
            lang: $i18n.locale
        },
    });">
      <i class="bi bi-bag"></i>
    </div>
  </div>

   <div v-for="(item, index) in DBitems.order_items.items" :key="index" class="d-flex align-items-center mb-3">
        <div class="position-relative me-3">
            <div class="product-image-container">
                <img :src="item.image" :alt="item.product" class="product-image order_item_image">
            </div>
            <div class="badge-custom">{{ (item.quantity) }}</div>
        </div>
        <div class="flex-grow-1">
            <div class="product-title item_order_cart_name">{{ item.product }}</div>
            <div class="product-subtitle">
                <div v-if="item.options.length != 0">
                    <span  v-for="(item1, i) in item.options"
                          :key="i">
                        {{ item1.option }} : {{ item1.value }} /
                    </span>
                </div>
                <div v-if="item.order_details.length != 0">
                    <p v-for="(item2, index) in item2.order_details" :key="index">
                        {{ item2 }}
                    </p>
                </div>
            </div>
        </div>
       
    <div class="price" >

      {{ ((item.total_price) * $store.state.rate).toFixed($store.state.digit_price) }} {{ $store.state.UnitPrice }}
    </div>
    </div>

 
  
  <div class="d-flex justify-content-between">
    <span class="summary-total">{{ $t("subTotal") }}</span>
    <span class="summary-total">{{ DBitems.total_price*$store.state.rate }} {{$store.state.UnitPrice}}
</span>
  </div>
  <div v-if="DBitems.discount_price>0" class="d-flex justify-content-between">
    <span class="summary-total">{{ $t("discount") }} ({{ DBitems.discount }}%)</span>
    <span class="summary-total"> {{ (DBitems.discount_price*$store.state.rate).toFixed($store.state.digit_price) }} {{$store.state.UnitPrice}}
</span>
  </div>

<div v-if="DBitems.delivery_cost>0" class="d-flex justify-content-between">
    <span class="summary-total">{{ $t("deliveryPrice") }}</span>
    <span class="summary-total">  {{ (DBitems.delivery_cost*$store.state.rate) }} {{$store.state.UnitPrice}}
</span>
  </div>

  <div v-if="DBitems.tax>0" class="d-flex justify-content-between">
    <span class="summary-total">{{ $t("tax") }} ( {{ DBitems.tax }}% ):</span>
    <span class="summary-total">  {{ (DBitems.tax_price*$store.state.rate).toFixed($store.state.digit_price)}} {{$store.state.unit}}
</span>
  </div>

   <div  class="d-flex justify-content-between">
    <span class="summary-total">{{ $t("totalPrice") }}</span>
    <span class="summary-total">  {{
                    DBitems.final_price*$store.state.rate
                    }} {{$store.state.UnitPrice}}
</span>
  </div>

        </div>
      </div>
    </div>
  </template>
  
  
<script>
import Vodal from "vodal";

import "vodal/common.css";
import "vodal/slide-down.css";
import "vodal/flip.css";
import { HollowDotsSpinner } from "epic-spinners";

export default {
  components: {
    Vodal,
     HollowDotsSpinner

  },
  data: function() {
    return {
      DBitems: null,
      loading: false,
      show: false,
      social: null,
      unit:'QAR',
      Message:"",
      show2:true,
    };
  },
  computed: {
    mail: function () {
      return feather.toSvg('mail')
    },
    phone: function () {
      return feather.toSvg('phone')
    },
    map_pin: function () {
      return feather.toSvg('map-pin')
    },
  },
  created() {
    let AllCookies = this.$cookies.keys();
      for (let i = 0; i < AllCookies.length; i++) {
      if (AllCookies[i].split("/")[0] == this.$store.storeName) {
        this.$cookies.remove(AllCookies[i]);
        ////PartialPrice
       
      }}
      this.$store.state.cartCounter=0;
    this.loading = true;
    this.unit=this.$store.state.unit;
    if(this.$i18n.locale == 'ar')
    {
        this.unit=this.$store.state.unitAR;
    }
    else
      {
        this.unit=this.$store.state.unit;
    }

    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/contact_us",
        {
          headers: {
            "Accept-Language": this.$i18n.locale
          }
        }
      )
      .then(response => {
        this.social = response.data.data.social;
       
    
      })


    this.axios
      .get(
        this.$store.state.base_api_url +
          this.$store.storeName +
          "/guest/order/" +
          this.$route.params.id,
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization:
              "Bearer " + this.$localStorage.get(this.$store.storeName)
          }
        }
      )
      .then(response => {
        if (response.data.code == "1") {
          this.DBitems = response.data.data.order;
        } else {
          console.log("errorrr");
        }
      })
      .then(() => (this.loading = false))
      .catch(error => {
        if (error.response.status == "401") {
         // this.$localStorage.remove(this.$store.storeName);
          //window.location.href = "/";
        }
      });
      if(this.$i18n.locale=='ar')
      {
      document.title = this.$store.state.title_ar;
      document.getElementById("description_meta").content=this.$store.state.description_ar;
      document.getElementById("keywords_meta").content=this.$store.state.keyword_ar;
      }
      else{
        document.title = this.$store.state.title_en;
      document.getElementById("description_meta").content=this.$store.state.description_en;
      document.getElementById("keywords_meta").content=this.$store.state.keyword_en;
      }
  },
  methods: {
    updatedata() {
      this.unit=this.$store.state.unit;
    if(this.$i18n.locale == 'ar')
    {
        this.unit=this.$store.state.unitAR;
    }
    else
      {
        this.unit=this.$store.state.unit;
    }
      this.loading = true;
      this.axios
        .get(
          this.$store.state.base_api_url +
            this.$store.storeName +
            "/guest/order/" +
            this.$route.params.id,
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName)
            }
          }
        )
        .then(response => {
          if (response.data.code == "1") {
            this.DBitems = response.data.data.order;
          } else {
            console.log("errorrr");
          }
        })
        .then(() => (this.loading = false))
        .catch(error => {
          if (error.response.status == "401") {
            // this.$localStorage.remove(this.$store.storeName);
            // window.location.href="/";
          }
        });

      //this.$refs.childref.update(this.categoryID)
      this.$store.state.langchange = false;
    },

    
    printInvoice() {
      let head = `
      <head>
<link href="https://etrolley.net/assets/vendor/animate.css/animate.min.css" rel="stylesheet">
    <link href="https://etrolley.net/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
    <link href="https://etrolley.net/assets/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
    <link href="https://etrolley.net/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
    <link href="https://etrolley.net/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
    <link href="https://etrolley.net/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
    <link href="https://etrolley.net/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">
    <link href="https://etrolley.net/assets/css/style.css" rel="stylesheet">
    <title>${this.$store.storeName}</title>
    <style>
    .btn {
    display: none !important;
  }
  .col-md-6 {
    width: 50% !important;
  } 
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
}
.container, .container-fluid, .container-xxl, .container-xl, .container-lg, .container-md, .container-sm {
    
    padding-right:20px
    padding-left: 20px
   
}
  .row {
    --bs-gutter-x: 1.5rem;
    --bs-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(-1 * var(--bs-gutter-y));
   
    }
    .list-unstyled {
    padding-left: 0;
    list-style: none;
}
/*.table-wrapper-scroll-y{
    display: block;
}
.my-custom-scrollbar{
    position: relative;
    max-height: 700px;
    overflow-x: auto;
    overflow-y: auto;
}*/
.table {
    --bs-table-color: var(--bs-body-color);
    --bs-table-bg: transparent;
    --bs-table-border-color: var(--bs-border-color);
    --bs-table-accent-bg: transparent;
    --bs-table-striped-color: var(--bs-body-color);
    --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
    --bs-table-active-color: var(--bs-body-color);
    --bs-table-active-bg: rgba(0, 0, 0, 0.1);
    --bs-table-hover-color: var(--bs-body-color);
    --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
    width: 100%;
    margin-bottom: 1rem;
    color: var(--bs-table-color);
    vertical-align: top;
    border-color: var(--bs-table-border-color);
    caption-side: bottom;
    border-collapse: collapse;
}
.table > thead {
    vertical-align: bottom;
}
thead, tbody, tfoot, tr, td, th {
    border-color: inherit;
    border-style: solid;
    border-width: 0;
}
thead {
    display: table-header-group;
    vertical-align: middle;
    border-color: inherit;
}
.table > :not(caption) > * > * {
    padding: 0.5rem 0.5rem;
    padding-top: 0.5rem;
    padding-right: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.5rem;
    background-color: var(--bs-table-bg);
    border-bottom-width: 1px;
    box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}
  .text-center {
    text-align: center !important;
}
.printLogo{
position: absolute;
    top: 0;
    left: 10px;
}
  </style>
  </head>
      `

      let body=``
      let invoice = document.getElementById("invoice").outerHTML
      if (this.$i18n.locale == "ar") {
        body=`<body dir='rtl'>
        ${ invoice }</body></html>`;
      } else {
         body=`<body dir='rtl'>
        ${ invoice }</body></html>`;
      }



      var mywindow = window.open("", "PRINT");

      mywindow.document.write("<html>");

      mywindow.document.
      //getElementsByTagName('head').
      write(head) ;
      mywindow.document.write(body);
      
      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();
    },

    Payment() {
      window.location.href = this.DBitems.link;
    }
  }
};
</script>

  <style scoped>
  #invoice1 {
    margin-top: 130px;
    margin-bottom: 50px;
    width: 84%;
    margin-left: 8%;
    margin-right: 8%;
  }
  .my-custom-scrollbar {
    position: relative;
    max-height: 700px;
    overflow-x: auto;
    overflow-y: auto;
  }
  .table-wrapper-scroll-y {
    display: block;
  }
  
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }
  
  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
  
  .modal-container {
    width: 300px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
  }
  
  .modal-header {
    margin-top: 0;
    color: var(--secondary-color) !important;
    font-family: "Araboto-Medium";
    margin-bottom: 20px;
  }
  
  .modal-body {
    margin: 20px 0;
    font-family: "Araboto-Medium";
  }
  
  .modal-default-button {
    float: right;
    font-family: "Araboto-Medium";
    margin-left: 5px;
    margin-right: 5px;
    font-size: 15px;
    border: 2px solid var(--primary-color);
    color: var(--secondary-color);
    border-radius: 5px;
  }
  .modal-default-button:hover {
    background-color: white;
  }
  
  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */
  
  .modal-enter-from {
    opacity: 0;
  }
  
  .modal-leave-to {
    opacity: 0;
  }
  
  .modal-enter-from .modal-container,
  .modal-leave-to .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  @media (max-width: 500px) {
    .title {
      font-size: 15px !important;
    }
    .btn {
      font-size: 8px !important;
      padding: 5px;
    }
  }
  
  @media print {
    .btn {
      display: none !important;
    }
    .col-md-6 {
      width: 50% !important;
    }
  }
  </style>
  
  
  